<div class="form-row m-0">
  <mat-form-field appearance="outline" class="input-id w-100">
      <input matInput autocomplete="off" [value]="inputLabel" #searchTextField type="text" [placeholder]="placeholder" [disabled]="disabled"
        (input)="onChangeContent($event)" (keyup.enter)="selectPlace()" />
      <button mat-button matSuffix mat-icon-button class="ml-2">
        <i *ngIf="!showSearchIcon && addressLabel" class="fas fa-times blue" (click)="reset(true)"></i>
        <i *ngIf="showSearchIcon || !addressLabel" class="fas fa-search blue" (click)="selectPlace()"></i>
      </button>
  </mat-form-field>
</div>
